import addressApi from './axiosClient'

export default {
  loadFooter: () => {
    return addressApi.get(`footers`)
  }
}
